var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"min-height":"450px","max-width":"750px"},attrs:{"id":"map"}}),_c('company-info-dialog',{ref:"companyInfoDialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }